import { checkParams, zeroUnit, soFarDate } from '../../utils'

export default function() {
	const { order, injured, setting, boardImageList } = this
	let arr = []
	if (!this.isResurveyNotInHospital) {
		const IDInfo = {
			title: '身份信息',
			children: [
				{ type: '0003', picName: '伤者身份证正面' },
				{ type: '0004', picName: '伤者身份证反面' },
				// { type: '0001', picName: '身份证明照' },
				{ type: '0002', picName: '对比照' },
			],
		}
		if (this.isMotion || this.isNewMotion) {
			IDInfo.children = IDInfo.children.concat([
				{ type: '1201', picName: '户口本户主页' },
				{ type: '1202', picName: '户口本家庭成员页' },
			])
		}
		arr.push(IDInfo)
	}

	if (!this.isResurveyNotInHospital) {
		if (!injured.caregiversDto || !injured.caregiversDto.hasCaregivers) {
			arr.push({
				title: '护理人材料',
				children: [
					{ type: '0801', picName: '护理人照片' },
					{ type: '0802', picName: '护理人资料' },
				],
			})
		} else if (injured.caregiversDto.hasCaregivers !== '0') {
			arr.push({
				title: '护理人材料',
				children: [
					{ type: '0801', picName: '护理人照片' },
					{ type: '0802', picName: '护理人资料' },
				],
			})
		}
	}

	const injuryInfo = {
		title: '伤情照片',
		children: [],
	}
	if (!this.isMotionAtHome && !this.isPAIC) {
		injuryInfo.children = injuryInfo.children.concat([
			{ type: '0106', picName: '医院门牌照' },
			{ type: '0101', picName: '科室门牌照' },
			{ type: '0102', picName: '病房门牌照' },
			{ type: '0103', picName: '床头卡' },
		])
	}
	if (!this.isMotionAtHome && this.isPAIC) {
		injuryInfo.children = injuryInfo.children.concat([
			{ type: '0106', picName: '医院门牌照' },
			{ type: '0112', picName: '作业人员与科室门牌合照' },
			{ type: '0102', picName: '病房门牌照' },
			{ type: '0103', picName: '床头卡' },
		])
	}
	if (this.isMotionAtHome) {
		injuryInfo.children = injuryInfo.children.concat([
			{ type: '0109', picName: '居住地大门照' },
			{ type: '0110', picName: '门牌号' },
			{ type: '0111', picName: '居住类证明' },
		])
	}
	if (this.isResurveyNotInHospital) {
		injuryInfo.children = injuryInfo.children.concat([
			{ type: '0107', picName: '病床照' },
			{ type: '0108', picName: '床头卡病床合影' },
		])
	} else {
		injuryInfo.children = injuryInfo.children.concat([
			{ type: '0104', picName: '伤者全身照' },
			{ type: '0105', picName: '受伤局部照' },
		])
	}
	if (this.isPAIC) {
		injuryInfo.children = injuryInfo.children.concat([
			{ type: '0113', picName: '作业人员与伤者合照' },
		])
	}
	arr.push(injuryInfo)

	const condition = {
		title: '病情资料',
		desc: `（要求：${
			this.isMotion || this.isNewMotion || this.isResurvey
				? '医嘱、每日费用清单、影像片（必传）。诊断证明、门诊病历本、检查报告、三个类型最少上传其中一种。）'
				: '诊断证明、检查报告、影像片为必传，门诊病历本为选传。）'
		}`,
		children: [],
	}
	if (this.isMotion || this.isNewMotion || this.isResurvey) {
		condition.children = condition.children.concat([
			{ type: '0502', picName: '医嘱' },
			{ type: '0503', picName: '每日费用清单' },
		])
	}
	condition.children = condition.children.concat([
		{ type: '0201', picName: '诊断证明' },
		{ type: '0202', picName: '门诊病历本' },
		{ type: '0203', picName: '检查报告' },
		{ type: '0501', picName: '影像片-片子全貌' },
		{ type: '050101', picName: '影像片-片头' },
		{ type: '050102', picName: '影像片-受伤细节' },
	])

	arr.push(condition)

	if (this.isResurvey) {
		const greeting = {
			title: '与伤者慰问合影',
			desc: this.isResurveyNotInHospital
				? '（要求：如伤者未在医院，可补充探视员与床位合影）'
				: '（要求：必须看清伤者和自己面部）',
			children: [
				{
					type: '0a01',
					picName: '与伤者慰问合影',
				},
			],
		}
		arr.push(greeting)
	}

	if (this.isMotion) {
		const motion = {
			title: '关节活动度测量',
			children: [],
			hasSubList: true,
		}
		const map = {
			'1101': [
				{ type: '110101', picName: '颈部活动度前屈' },
				{ type: '110102', picName: '颈部活动度后伸' },
				{ type: '110103', picName: '颈部活动度左侧屈' },
				{ type: '110104', picName: '颈部活动度右侧屈' },
				{ type: '110105', picName: '颈部活动度左旋转' },
				{ type: '110106', picName: '颈部活动度右旋转' },
			],
			'1102': [
				{ type: '110201', picName: '腰椎前屈' },
				{ type: '110202', picName: '腰椎后伸' },
				{ type: '110203', picName: '腰椎左侧屈' },
				{ type: '110204', picName: '腰椎右侧屈' },
				{ type: '110205', picName: '腰椎左侧旋' },
				{ type: '110206', picName: '腰椎右侧旋' },
			],
			'1103': [
				{ type: '110301', picName: '肩关节屈曲' },
				{ type: '110302', picName: '肩关节伸展' },
				{ type: '110303', picName: '肩关节外展' },
				{ type: '110304', picName: '肩关节内旋' },
				{ type: '110305', picName: '肩关节外旋' },
				{ type: '110306', picName: '肩关节伸屈展' },
			],
			'1104': [
				{ type: '110401', picName: '肘关节屈曲' },
				{ type: '110402', picName: '肘关节伸展' },
				{ type: '110403', picName: '肘关节旋前' },
				{ type: '110404', picName: '肘关节旋后' },
			],
			'1105': [
				{ type: '110501', picName: '腕关节掌屈' },
				{ type: '110502', picName: '腕关节背伸' },
				{ type: '110503', picName: '腕关节桡屈' },
				{ type: '110504', picName: '腕关节尺屈' },
			],
			'1106': [
				{ type: '110601', picName: '髋关节伸展' },
				{ type: '110602', picName: '髋关节前屈' },
				{ type: '110603', picName: '髋关节外展' },
				{ type: '110604', picName: '髋关节内收' },
			],
			'1107': [
				{ type: '110701', picName: '膝关节内旋' },
				{ type: '110702', picName: '膝关节外旋' },
				{ type: '110703', picName: '膝关节屈曲' },
			],
			'1108': [
				{ type: '110801', picName: '踝关节背屈' },
				{ type: '110802', picName: '踝关节跖屈' },
			],
			'1109': [
				{ type: '110901', picName: '第一指屈曲' },
				{ type: '110902', picName: '第一指间关节屈曲' },
			],
			'1110': [
				{ type: '111001', picName: '第二、三、四、五指屈曲' },
				{ type: '111002', picName: '第二、三、四、五间关节屈曲' },
			],
		}
		const motionArr = order.injuryPositions.split(',')
		for (const i of motionArr) {
			motion.children.push(map[i])
		}

		arr.push(motion)
	}
	if (this.isPAIC) {
		arr.push({
			title: '资料补传',
			children: boardImageList,
		})
	}
	arr.push({
		title: '电子签名',
		slot: 'sign',
	})

	const signIn = {
		title: '签到',
		children: [],
	}
	let mediaInfoList = []
	if (injured.mediaInfoList && injured.mediaInfoList.length) {
		mediaInfoList = injured.mediaInfoList
	}
	if (mediaInfoList.find(item => item.type === '0402')) {
		signIn.children.push({ type: '0402', picName: '作业人员和伤者合照' })
	} else if (mediaInfoList.find(item => item.type === '0401')) {
		signIn.children.push({ type: '0401', picName: '作业人员和床头卡合照' })
	} else if (this.isMotionAtHome) {
		signIn.children.push({ type: '0403', picName: '本人与居住地门牌合照' })
	} else {
		signIn.children.push({ type: '0405', picName: '本人与医院大门合照' })
	}

	arr.push(signIn)

	if (this.isCarInsurance) {
		if (order.hasManual === '1' && !this.isResurveyNotInHospital) {
			arr.push({
				title: '服务手册',
				children: [{ type: '1001', picName: '伤者和服务手册合照' }],
			})
		}
	} else {
		if (order.hasManual === '1' && !this.isResurveyNotInHospital) {
			arr.push({
				title: '联络卡',
				children: [{ type: '1002', picName: '伤者和联络卡合照' }],
			})
		}
	}

	if (this.isWholeProcess && this.isResurvey) {
		const responsibility = {
			title: '事故责任认定书',
			desc: '（要求：内容拍摄完整，文字清晰可见）（非必传）',
			children: [
				{
					type: '0b01',
					picName: '事故责任认定书',
				},
			],
		}
		arr.push(responsibility)
	}

	if (!this.isResurveyNotInHospital) {
		arr.push({
			title: '银行卡',
			desc: '（非必传）',
			children: [{ type: '0601', picName: '银行卡' }],
		})
	}

	arr.push(
		{
			title: '其他',
			desc: '（非必传）',
			children: [{ type: '0900', picName: '其他' }],
		},
		{
			title: '视频信息',
			desc: '（非必传）',
			slot: 'videoList',
		}
	)

	return arr
}
